exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.bread-crumb-list{display:flex;align-items:center;gap:10px;height:50px}.bread-crumb-list .back-arrow{background-image:url(" + require("../../assets/images/back-icon.svg") + ");background-repeat:no-repeat;width:18px;height:15px;background-size:18px 15px;cursor:pointer;display:flex;align-items:center}.bread-crumb-list .bread-crumbs{display:flex;flex-direction:row;align-items:center;gap:10px;height:50px}.bread-crumb-list .bread-crumbs .bread-crumb{display:flex;align-items:center;font-family:Open Sans,sans-serif;font-weight:600;font-size:16px;color:#bababa;letter-spacing:normal;height:16px;cursor:pointer}.bread-crumb-list .bread-crumbs .bread-crumb.selected .bread-crumb__name{border-bottom:none;color:#184e78;cursor:default!important}.bread-crumb-list .bread-crumbs .bread-crumb__name{height:19px;pointer-events:auto;max-width:240px;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;display:flex;align-items:center}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/BreadCrumbs/BreadCrumbs.scss
// module id = 1523
// module chunks = 0